export default __webpack_public_path__ + "static/bg-02928396245cbdef52ac91497ba92dc8.webm";